import { createStyles } from '@material-ui/core';

const styles = () => createStyles({
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
});

export default styles;
